// src/api_scripts/createAddressBook.js
import { createApiClient } from "../apiClient";

// Updated parameters: (name, description, parentType, orgId, accessToken, setProgress)
const createAddressBook = async (addressbookData, orgId, accessToken, setProgress) => {
  const { name } = addressbookData.name;

  // Use the structured setProgress for consistency and better logging
  setProgress((prev) => [
    ...prev,
    { type: 'info', message: `Attempting to create Address Book: "${name}"...`, timestamp: new Date().toLocaleTimeString() }
  ]);
  setProgress(`Attempting to create Address Book: "${name}"...`, "info" );

  // Construct the relative URI for the POST request
  const relativeUri = `organization/${orgId}/v3/address-book`;
  let requestBody;

  try {
    // Create the API client instance with the access token
    const apiClient = createApiClient(accessToken);

    const response = await apiClient.post(relativeUri, addressbookData);
    const result = response.data; // Access the actual data from the Axios response

    console.log("Create Address Book API Response Data:", result);

    if (result && result.id) {
      // Use the structured setProgress for consistency and better logging
      setProgress((prev) => [
        ...prev,
        { type: 'success', message: `Successfully created Address Book "${name}" with ID: ${result.id}`, timestamp: new Date().toLocaleTimeString() }
      ]);
      return result.id; // Return the ID of the newly created address book
    } else {
      // Use the structured setProgress for consistency and better logging
      setProgress((prev) => [
        ...prev,
        { type: 'error', message: `Failed to create Address Book "${name}". No ID returned or unexpected response.`, timestamp: new Date().toLocaleTimeString() }
      ]);
      return null;
    }

  } catch (error) {
    console.error(`Error creating Address Book "${name}":`, error);

    let errorMessage = `Error creating Address Book "${name}": ${error.message || String(error)}`;

    // Check for specific API error response structure to add more detail
    if (error.response && error.response.data && error.response.data.error && error.response.data.error.reason) {
      errorMessage += ` (Reason: ${error.response.data.error.reason})`;
    }

    // Use the structured setProgress for consistency and better logging
    setProgress((prev) => [
      ...prev,
      { type: 'error', message: errorMessage, timestamp: new Date().toLocaleTimeString() }
    ]);
    throw error; // Re-throw the error for centralized handling in SpreadsheetProcessor.js
  }
};

export default createAddressBook;
